"use client";

import { Table, TableBody, TableHead, TablePagination } from "@mui/material";
import React from "react";

import {
  HeaderTableCell,
  TableContainer,
  TableHeaderRow,
} from "@/components/molecules/Table/styled";
import { DEFAULT_ROWS_PER_PAGE_OPTIONS } from "@/constants/pagination";
import useAuth from "@/contexts/auth-context";
import ISubject from "@/interfaces/subject.interface";
import { SubjectMessages } from "@/messages/subject/subject.messages";
import { Pagination } from "@/types/page.types";
import { PaginatedResponse } from "@/types/requests.types";

import { SubjectTableRow } from "./row";
import { SUBJECT_TABLE_COLUMNS } from "../../constants";

interface SubjectTableProps {
  data: PaginatedResponse<ISubject>;
  pagination: Pagination;
  messages: SubjectMessages;
}

export function SubjectTable({ data, pagination, messages }: SubjectTableProps) {
  const { pageNumber, pageSize, changePage, extend } = pagination;
  const { user: currentUser } = useAuth();
  const columns = SUBJECT_TABLE_COLUMNS(messages);

  return (
    <>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableHeaderRow>
              {columns.map((label, index) => (
                <HeaderTableCell key={`${index} - ${label}`}>{label}</HeaderTableCell>
              ))}
            </TableHeaderRow>
          </TableHead>
          <TableBody>
            {currentUser &&
              data.items.map((subject, index) => (
                <SubjectTableRow
                  key={`${index} - ${subject.id}`}
                  index={index}
                  subject={subject}
                  messages={messages}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        labelRowsPerPage={messages.rowsPerPage}
        rowsPerPageOptions={DEFAULT_ROWS_PER_PAGE_OPTIONS}
        component="div"
        count={data.totalCount}
        onRowsPerPageChange={(e) => extend(Number(e.target.value))}
        rowsPerPage={pageSize}
        page={pageNumber - 1}
        onPageChange={(_, pageNumber) => changePage(pageNumber)}
      />
    </>
  );
}
